export default __webpack_public_path__ + "media/images/dashboard_icons/tableplan-23c811948c8b468dcb7474154c799b34.svg";